import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_43_0 = () => {
  return (
    <div>
      <PageTitle title='3.43.0' />

      <ParaTitle paraTitle='Bug Fixes & Data Exports' />
      <Paragraph paragraph='2025-07-14' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Facility sundown page
          <p>The facility sundown page now indicates how simple or complex it is to deactivate a facility. 
            This change helps streamline the sundown process by providing a clear guide and procedure, 
            making it easier for developers and facilities that are leaving the system.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Upgraded system to PHP 8.4.10, Apache 2.4.63, and Debian 12.11
          <p>
            Upgraded the system environment to PHP 8.4.10, Apache 2.4.63, and Debian 12.11 
            to enhance security, performance, and compatibility.
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Duplicates in TSN feedback reports 
          <p>Fixed the counting issue in feedback reports.</p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.44.0', link: '/updates/3.44.0' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_43_0;